import React, { useContext } from "react";
import { CustomerContext } from "./CustomerContext";
import { Link, Outlet } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

export default function CustomerFarmers() {
  let { data, availableFarmers, formik, setRelToDel } = useContext(CustomerContext);

  const foundFarmerNames = availableFarmers.length > 0 ? availableFarmers.map((farmer) => farmer.username) : null;

  return (
    <div className="bg-gray-100 mt-2 mb-16">
      <div>        
        <Link to="/customerDash/communicate/farmers">Communicate</Link>
        <Outlet />
      </div>
      <h3>FARMERS</h3>
      <div>
        {data[0]?.Farmers?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 border border-gray-100">
            {data[0].Farmers.map((farmer, index) => (
              <div key={index} className="relative">
                <div className="max-w-[100px] mx-auto mb-10 block">
                  <FontAwesomeIcon
                    icon={faUser}
                    className="w-full h-auto max-w-[250px] min-w-fit mx-auto mb-10 block"
                    style={{ maxWidth: "100px" }} // Ensure the max width is 250px
                  />
                </div>
                <div className="absolute top-0 left-0 right-0 z-10 flex flex-row justify-between p-2 text-sm">
                  <p className="text-gray-900 bg-white rounded-lg">{farmer.username}</p>
                  <form onSubmit={formik.handleSubmit}>
                    <button
                      className="bg-blue-500 rounded-full px-2 py-1 text-white"
                      type="submit"
                      onClick={(e) => {
                        setRelToDel(true);
                        formik.setFieldValue("name", farmer.username);
                      }}
                    >
                      DELETE
                    </button>
                  </form>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p>It seems you have no farmers. Want to add one?</p>
        )}
      </div>
      {availableFarmers.length > 0 ? (
        <form onSubmit={formik.handleSubmit}>
          <label htmlFor="name">Select a farmer</label>
          <select
            value={formik.values.name}
            name="name"
            id="name"
            onChange={formik.handleChange}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          >
            <option value="">Select a farmer</option>
            {foundFarmerNames.map((farmer, index) => (
              <option value={farmer} key={index}>
                {farmer}
              </option>
            ))}
          </select>
          <button
            className="bg-blue-500 rounded-lg text-white disabled:opacity-50"
            type="submit"
            onClick={(e) => {
              setRelToDel(false);
            }}
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Send Request
          </button>
        </form>
      ) : null}
    </div>
  );
}
